import React from "react";
import "./style.css";
import Accordion from "react-bootstrap/Accordion";
import { Card, Button } from "react-bootstrap";

const FaqSection = () => {
  return (
    <section className="faq-area section-padding">
      <div className="container">
        <div className="row">
          <div className="col-12">
            <div className="section-title">
              <span>FAQ</span>
              <h2>Frequently Asked Question</h2>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-lg-12">
            <Accordion className="choose-info" defaultActiveKey="0">
              <Card>
                <Card.Header>
                  <Accordion.Toggle as={Button} variant="link" eventKey="0">
                    What sets BTurner Law apart from other law firms?
                  </Accordion.Toggle>
                </Card.Header>
                <Accordion.Collapse eventKey="0">
                  <Card.Body>
                    We prioritize personalized service, deep legal expertise,
                    and a commitment to achieving your real estate, estate
                    planning, and corporate legal goals.
                  </Card.Body>
                </Accordion.Collapse>
              </Card>
              <Card>
                <Card.Header>
                  <Accordion.Toggle as={Button} variant="link" eventKey="1">
                    What is the typical turnaround time for real estate
                    transactions?
                  </Accordion.Toggle>
                </Card.Header>
                <Accordion.Collapse eventKey="1">
                  <Card.Body>
                    Turnaround times can vary, but our efficient processes and
                    experienced team work diligently to ensure timely closings.
                  </Card.Body>
                </Accordion.Collapse>
              </Card>
              <Card>
                <Card.Header>
                  <Accordion.Toggle as={Button} variant="link" eventKey="2">
                    How does BTurner Law keep clients informed throughout the
                    legal process?
                  </Accordion.Toggle>
                </Card.Header>
                <Accordion.Collapse eventKey="2">
                  <Card.Body>
                    We maintain open communication with our clients, providing
                    regular updates and addressing any concerns promptly.
                  </Card.Body>
                </Accordion.Collapse>
              </Card>
            </Accordion>
          </div>
        </div>
      </div>
    </section>
  );
};
export default FaqSection;
